import { getCurrentLocale } from '@leagueplatform/locales';
import type { LocalesKey } from 'common/types/types';
import EN_STRING_OVERRIDES from 'locales/en.json';
import ES_STRING_OVERRIDES from 'locales/es.json';
import KO_STRING_OVERRIDES from 'locales/ko-US.json';
import ZH_STRING_OVERRIDES from 'locales/zh.json';
import VI_STRING_OVERRIDES from 'locales/vi.json';

export const locale = getCurrentLocale()?.split('-')[0];

const getLocalesFile = () => {
  switch (locale) {
    case 'es':
      return ES_STRING_OVERRIDES;
    case 'ko':
      return KO_STRING_OVERRIDES;
    case 'zh':
      return ZH_STRING_OVERRIDES;
    case 'vi':
      return VI_STRING_OVERRIDES;
    default:
      return {}; // Return empty because below we're merging it with EN_STRING_OVERRIDES
  }
};
type LocaleOverrides = Record<LocalesKey, string>;

const localesObject: LocaleOverrides = {
  ...EN_STRING_OVERRIDES,
  ...getLocalesFile(),
};

const overrideKeys = [
  'clear',
  'close',
  'dismiss',
  'externalLink',
  'loadingText',
  'newTabInternal',
  'newWindowInternal',
  'next',
  'optional',
  'previous',
];

const localesKeyPrefix = 'STR_THEME_';

export const THEME_STRING_OVERRIDES = overrideKeys.reduce(
  (result, overrideKey) => {
    const key = (localesKeyPrefix + overrideKey) as LocalesKey;
    return {
      ...result,
      [overrideKey]: localesObject[key],
    };
  },
  {},
);
